import React, {Fragment} from 'react';

const RatingSimpleElement = ({rating, ratingPrompt, acceptablePrompt, unAcceptablePrompt, notObservedPrompt, notResponsivePrompt, comment, useNoNr, timeSpendFieldPrompt, timeSpend}) => {

  return (
    <div className='dynamic-report-item'>
      <div className='label' style={{whiteSpace: 'pre-wrap'}}>
        {ratingPrompt}
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div className="field field-with-icon">
          {rating === 'acceptable'
            ? <i className="fa fa-check-square-o"/>
            : <i className="fa fa-square-o"/>}
          <span className="response">{acceptablePrompt || 'Acceptable'}</span>
        </div>
        <div className="field field-with-icon">
          {rating === 'unAcceptable'
            ? <i className="fa fa-check-square-o"/>
            : <i className="fa fa-square-o"/>}
          <span className="response">{unAcceptablePrompt || 'Unacceptable'}</span>
        </div>
        {useNoNr && (
          <Fragment>
            <div className="field field-with-icon">
              {rating === 'notObserved'
                ? <i className="fa fa-check-square-o"/>
                : <i className="fa fa-square-o"/>}
              <span className="response">{notObservedPrompt || 'Not observed'}</span>
            </div>
            <div className="field field-with-icon">
              {rating === 'notResponsive'
                ? <i className="fa fa-check-square-o"/>
                : <i className="fa fa-square-o"/>}
              <span className="response">{notResponsivePrompt || 'Not responsive'}</span>
            </div>
          </Fragment>
        )}
      </div>

      {timeSpend && (
        <div>
          <span>{timeSpendFieldPrompt || 'Time spend on this observation'} {timeSpend}</span>
        </div>
      )}

      { (!!comment) && (
        <Fragment>
          <div className='label' style={{paddingTop: '15px'}}>
            Comments
          </div>
          <div className="field field-with-icon">
            { comment
              ? <span style={{wordWrap: 'break-word'}}>{comment}</span>
              : <span>No comment</span>
            }
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default RatingSimpleElement;
